import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { authUser } from 'api/aaaService';
import { makeAutoObservable, runInAction } from 'mobx';
import { RootStore } from 'store/rootStore';
import { AuthUserParams } from 'types/aaaService';

interface FormFields extends DefaultFormFields {
  email: FormControl<string>;
  password: FormControl<string>;
}

export default class SignInFormStore {
  rootStore: RootStore;
  loading = false;
  errorCode: number | null = null;
  signInForm: FormController<FormFields>;

  setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  public setErrorCode(error: number | null): void {
    this.errorCode = error;
  }

  public async signIn(): Promise<void> {
    this.setErrorCode(null);

    const { email, password } = this.signInForm.fields;
    const data: AuthUserParams = { email: email.value, password: password.value };
    this.setLoading(true);
    const res = await this.rootStore.requestProcessor.processRequest(authUser, data);
    runInAction(() => {
      if (res) {
        switch (res.status) {
          case 200:
            this.rootStore.loginSessionStore.logInUser();
            this.setLoading(false);
            this.signInForm.resetForm();
            break;

          default:
            this.setErrorCode(res.status);
            this.setLoading(false);
            break;
        }
      }
    });
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    this.signInForm = new FormController({
      email: new FormControl<string>('', { validations: ['isEmailValid'] }),
      password: new FormControl<string>('', {}),
    });

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
